module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1200.2b6cde71.svg";